// basic usage:
// trackLoadTask("taskName", TYPE.Start)
// trackLoadTaskStart("taskName")
// trackLoadTaskEnd("taskName")
// Module handles tracking time between these two entirely; so will need a .init

import Game from '../Game';
import { FBTrackingEvent } from './Tracking/FBTrackingEvent';

export enum LoadEventType {
    Start,
    End
}

export enum LoadEvents {
    FB_preStartGame = "fb_psg",
    GB_loginFlow = "gb_lf",
    SOFA_miscLoading1 = "sofa_misc1",
    SOFA_miscLoading2 = "sofa_misc2",
    SOFA_worldSystemPreload = "sofa_wsp",
    SOFA_levelSystemPreload = "sofa_lsp"
}

interface ILoadtimeTrackerSettings {
    autoInit?: boolean
}

interface ILoadtimeTrackerTask {
    key: string;
    timeStarted: number;
    timeFinished: number | undefined;
}

/**
 * Where %k is the event key
 */
const TEMPLATE_STRING: string = "loadTime_%k";

const TRACKING_THRESHOLDS = [
    1500,
    4000,
    7000
];

const DEFAULT_SETTINGS: ILoadtimeTrackerSettings = {
    autoInit: false,

}

class LoadtimeTracker {

    private _isInitialized: boolean = false;

    private _tasks: Array<ILoadtimeTrackerTask> = [];

    constructor(_settings: ILoadtimeTrackerSettings) {

        if(!_settings.autoInit) {
            this.init();
        }
    }

    public init(): Promise<void> {
        this._isInitialized = true;
        return Promise.resolve();
    }

    public trackLoadTask(_key: LoadEvents, _type: LoadEventType): void {
      /*  const existingTask: ILoadtimeTrackerTask = this.findTaskByKey(_key);

        switch(_type) {
            case LoadEventType.Start:
            default:
                if(existingTask) {
                    console.warn(`Cannot start existing tracking task "${_key}"`);
                    return;
                }
                this._tasks.push({
                    key: _key,
                    timeStarted: LoadtimeTracker.getCurrentTimestamp()
                } as ILoadtimeTrackerTask);
                break;
            case LoadEventType.End:
                if(!existingTask || Boolean(existingTask.timeFinished)) {
                    console.warn(`Cannot end non-existent tracking task "${_key}"`);
                    return;
                }
                existingTask.timeFinished = LoadtimeTracker.getCurrentTimestamp();
                LoadtimeTracker.sendEvent(existingTask);
                break;
        }*/
    }

    private static sendEvent(_task: ILoadtimeTrackerTask): void {
        const timeTaken: number = _task.timeFinished - _task.timeStarted;
        const str: string = TEMPLATE_STRING.replace("%k", _task.key);
        const thresh: number = TRACKING_THRESHOLDS.find((e, i, a) => (timeTaken < e));
        const thresholdStr: string = `${
            thresh ? "sub" : "above"
        }${
            (thresh || TRACKING_THRESHOLDS[TRACKING_THRESHOLDS.length - 1])
                .toString()
        }`;

        // This is basically logged by the SDK driver, but will leave here for debugging purposes
        //LoadtimeTracker.logToConsole(`Logging event ${str} with value ${timeTaken} and threshold of ${thresholdStr}`);

        try {
            Game.sdk.gameTracking(
                // we live outside the law, where our events hide from the upper-class
                str as FBTrackingEvent,
                timeTaken,
                {
                    "threshold": thresholdStr
                }
            )
        } catch(err) {
            console.error(err);
        }
    }

    private static logToConsole(str: string): void {
        console.log(`[LoadtimeTracker] ${str}`);
    }

    private findTaskByKey(_key: string) {
        return this._tasks.find((e: ILoadtimeTrackerTask) => e.key === _key);
    }

    private static getCurrentTimestamp(): number {
        // todo: make more accurate?
        return Date.now();
    }

}

export const LoadtimeTrackerSingleton = new LoadtimeTracker(DEFAULT_SETTINGS);
